var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile--programs-list"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"10"}},[_c('program-revenue-table',{attrs:{"programs":_vm.programs,"total":_vm.total,"loading":_vm.loading}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }